import React from 'react'
import { ErrorHandler } from './Error-Handler';

const Layout = ({children}) => (<main className="flex h-screen overflow-hidden">{children}</main> )
const Sidebar = ({children}) =>  (<aside > {children}</aside>)
const Header = ({ children }) => (<header> <div className="px-4 bg-gray-400 h-12"> {children} </div> </header>)

const Page = ({children}) => {
  const [page] = 0//useRecoilState(navigation)
  return (
    <div className="w-full">
      {children[page]}
    </div>
  )
}


Layout.Sidebar = ErrorHandler(Sidebar);
Layout.Page = ErrorHandler(Page);
Layout.Header = ErrorHandler(Header);

export default Layout